import '../styles/Hero.css';

function Hero() {
  return (
    <section className="hero" id="accueil">
      <div className="hero-container">
        <div className="hero-content">
          <h1 className="hero-title">
            Formez-vous au digital<br />
            et préparez votre Hijra
          </h1>
          <p className="hero-subtitle">
            Apprenez des compétences concrètes (WordPress, SEO, IA)<br />
            pour construire une activité durable et indépendante.
          </p>
          <div className="hero-buttons">
            <a href="#formations" className="btn btn-primary">Commencer maintenant</a>
            <a href="#formations" className="btn btn-outline">Voir les formations</a>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Hero;
